export default "__VITE_ASSET__7bf86114__"